import React from 'react';
import './GroundStateBadge.css';

/**
 * The solid state pill used on On Ground and Departures, so one aircraft reads the same on
 * both tabs. Colours come from the --ground-* theme variables (theme.css); Mono maps them to
 * greys, and every state has its own label, so nothing depends on hue alone.
 *
 * Accepts both vocabularies:
 *   On Ground (AirportViewService.groundState): taxiing_in, taxiing_out, taxiing, pushback,
 *     parked, holding, plus the legacy uppercase TAXIING_IN / ENGINES_ON / ...
 *   Departures (departure_forecast.state, after effectiveState): POWER_ON, TAXIING, TAKE_OFF,
 *     DEPARTED, PARKED
 */
const STATES = {
  taxiing_in:  { cls: 'taxi-in',    label: 'Taxiing In' },
  taxiing_out: { cls: 'taxi-out',   label: 'Taxiing Out' },
  taxiing:     { cls: 'taxi-out',   label: 'Taxiing' },
  pushback:    { cls: 'pushback',   label: 'Pushback' },
  parked:      { cls: 'parked',     label: 'Parked' },
  holding:     { cls: 'holding',    label: 'Holding' },
  engines_on:  { cls: 'engines-on', label: 'Engines On' },
  // Departures: POWER_ON is engines running at the stand, TAXIING is taxi-out.
  power_on:    { cls: 'engines-on', label: 'Engines On' },
  take_off:    { cls: 'take-off',   label: 'Take-off' },
  departed:    { cls: 'departed',   label: '✓ Departed' },
};

export function groundStateView(state, { departure = false } = {}) {
  if (!state) return null;
  const k = String(state).toLowerCase();
  // On the Departures board TAXIING is always outbound.
  if (departure && k === 'taxiing') return STATES.taxiing_out;
  return STATES[k] || { cls: 'unknown', label: String(state) };
}

export default function GroundStateBadge({ state, departure = false }) {
  const v = groundStateView(state, { departure });
  if (!v) return <span className="ground-state-none">—</span>;
  return <span className={`ground-state ground-state-${v.cls}`}>{v.label}</span>;
}
